import { Edit } from '@material-ui/icons';
export interface IAccountSettingsDrawerListItem {
  /** Name for the item */
  name: string
  /** URL the item links to */
  url?: string;
  /** An alternate list of lists to mark this item as active */
  altURLs?: string[]
  id?: number
}

export interface IAccountSettingsDrawerGroupItem {
  /** The name of the main button or collapsible group */
  groupName?: AccountSettingsGroupItemName

  /** Link assigned to the main collapsible button if `groupItems` is not provided */
  url?: string 

  /** A list of items shown when the collapsible is activated */
  groupItems?: IAccountSettingsDrawerListItem[]
  onClick?: () => void;
}

export enum AccountSettingsGroupItemName {
  EDIT_PROFILE = 'Edit Profile',
  NOTIFICATIONS = 'Notifications',
  SECURITY = 'Security'
}

export enum EditProfileGroupItemName {
  PERSONAL_BIO = 'Personal Bio',
  CAREER_SUMMARY = 'Career Summary',
  UPLOAD_RESUME = 'Upload Resume',
  MAIN_GOALS = 'Main goal(s) for joining Obsidi'
}

export enum NotificationsGroupItemName {
  EMAIL_NOTIFICATIONS = 'Email Notifications',
}